import { useTranslation } from 'react-i18next'

import { ProjectStatus, ProjectStatusType } from '@/schema'
import { cn } from '@/utils/common'

export type StatusVariant = 'active' | 'archived' | 'invalid'

export interface StatusBadgeProps {
  status: ProjectStatusType | string
  variant?: StatusVariant
  className?: string
}

export const StatusBadge = ({
  status,
  variant,
  className,
}: StatusBadgeProps) => {
  const { t } = useTranslation()

  const getVariant = (): StatusVariant => {
    if (variant) return variant

    const statusLower = status.toLowerCase()
    if (statusLower === ProjectStatus.ACTIVE) return ProjectStatus.ACTIVE
    if (statusLower === ProjectStatus.ARCHIVED) return ProjectStatus.ARCHIVED

    return 'invalid'
  }

  const getDisplayLabel = (): string => {
    const statusLower = status.toLowerCase()

    if (statusLower === ProjectStatus.ACTIVE) return t('project.status.active')
    if (statusLower === ProjectStatus.ARCHIVED)
      return t('project.status.archived')

    return t('project.status.invalid')
  }

  const currentVariant = getVariant()

  const variantStyles: Record<StatusVariant, string> = {
    active:
      'bg-[--Colors-Brand-50] text-[--Colors-Brand-700] border-[--Colors-Brand-200]',
    archived:
      'bg-[--Colors-Success-50] text-[--Colors-Success-700] border-[--Colors-Success-200]',
    invalid:
      'bg-[--Colors-Warning-50] text-[--Colors-Warning-700] border-[--Colors-Warning-200]',
  }

  return (
    <span
      className={cn(
        'inline-flex items-center justify-center text-xs px-2 py-0.5 rounded-full font-medium border border-solid',
        variantStyles[currentVariant],
        className
      )}
    >
      {getDisplayLabel()}
    </span>
  )
}
